import http from 'hub-http/clients/apiClient';
import { mapContentData } from 'personalization-lib/utils/assetData/content';
import { TARGETED_CONTENT_URL } from 'personalization-lib/constants/urls';
export const fetchContentByIds = async ({
  url,
  ids
}) => {
  const contentUrl = `${url}?id__in=${ids.join(',')}&limit=${ids.length}`;
  const {
    objects
  } = await http.get(contentUrl);
  return objects.map(mapContentData);
};
export const fetchHasSmartContent = async ({
  id
}) => {
  const smartContent = await http.get(`${TARGETED_CONTENT_URL}/${id}`);
  return smartContent.length > 0;
};